import { render } from "./DowntimesHosts.vue?vue&type=template&id=3681ae36"
import script from "./DowntimesHosts.vue?vue&type=script&lang=js"
export * from "./DowntimesHosts.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__